<template>
  <div class="html">
    <div class="introduce">
      <p class="sub_title red">
        大咖云集，齐聚汴梁，由河南省委网信办主办、开封市委网信办承办、河南灵创电子科技有限公司协办的河南省2023年国家网络安全宣传周高峰论坛--“打造网络安全运营体系,助推数字经济发展”在开封圆满召开
      </p>
      <div class="content_A">
        <div class="content_list">
          <div>
            在这个数字化时代，网络安全已经成为我们共同关注的话题。作为一家河南本土的网络安全服务商，河南灵创电子科技有限公司（以下简称灵创科技）一直致力于为客户提供安全可靠的解决方案和服务，同时也积极参与网络安全运营领域的建设和发展。
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic1.png"
              alt=""
            >
          </div>
          <div class="blue">
            大咖云集 · 共话网络安全运营前沿发展
          </div>
          <div>
            在2023年国家网络安全周的浓厚氛围中，我们荣幸作为协办单位，参与了由河南省委网信办主办、开封市委网信办承办的“打造网络安全运营体系，助推数字经济发展”主题论坛。
          </div>
          <div>
            活动现场汇集了一百多位各行各业的专家和企业代表，共同探讨网络安全运营实践和数字经济的发展趋势。
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic2.png"
              alt=""
            >
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic3.png"
              alt=""
            >
          </div>
          <div>
            活动现场，开封市互联网舆情研究和应急保障中心主任于海刚出席论坛并发表致辞。于海刚主任表示：“随着信息技术的快速发展和互联网的广泛普及，网络安全问题已经成为全社会普遍关注的重要议题。因此，打造网络安全运营体系，保障网络安全的任务日益紧迫和必要。”
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic4.png"
              alt=""
            >
          </div>
          <div>
            作为本次论坛的协办方，灵创科技总经理杨清泉在致辞中表示：“预祝本次高规格、大规模的网络安全运营学术论坛成功召开。希望通过本次论坛的举办，能够多角度多维度地开拓网络安全运营事业的思路创新，提升安全运营的技术与理念。”同时，他还表示：“灵创科技以后将一如既往地通过学术峰会、论坛等形式，不断助力于搭建各种交流平台，为推进中国网络安运营事业的发展贡献一己之力。”
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic5.png"
              alt=""
            >
          </div>
          <div class="blue">
            传道授业 · 数位专家教授倾囊相授
          </div>
          <div>
            为了更好地探讨网络安全运营的落地实践问题，此次分论坛还邀请了四位省内不同行业的专家，他们分别是：
          </div>
          <div>
            河南省卫生健康人才中心陈益洲处长，演讲主题是《新时期卫生健康行业网络安全体系建设》；他详细阐述了卫生健康行业中网络安全的重要性以及应对策略，让人们深刻认识到网络安全对医疗行业的影响。
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic6.png"
              alt=""
            >
          </div>
          <div>
            河南省营商环境和社会信用建设中心原副主任、教授级高工于颖，演讲主题是《新时期政务信息化安全运营思考》。她深入浅出地讲解了安全运营如何保证政务信息化过程的几个关键点，使大家了解到网络安全在政务信息化建设中的重要性。
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic7.png"
              alt=""
            >
          </div>
          <div>
            郑州自来水投资控股有限公司档案信息中心主任、高级工程师尹建四，演讲主题是《构筑网络安全运营体系，助力智慧水务建设》。他结合自己的实践经验，分享了如何在水务行业中构建网络安全运营体系，提升智慧水务的安全防护能力。
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic8.png"
              alt=""
            >
          </div>
          <div>
            河南灵创电子科技有限公司产品经理、国家注册信息安全工程师胡迪，演讲主题是《攻击视角下的安全运营》。他表示：“以往的网络安全防护大多以防御者视角为出发点，但在网络边界逐渐被打破的情况下，企业对于被保护的资产都不能清晰掌握，又何谈安全。攻击视角下的网络安全运营是我们在实践中发现的一个非常具有挑战性和实用性的视角。从攻击者的角度来看待网络安全，可以更好地理解网络威胁的本质，以及如何采取有效的防御措施。通过深入了解攻击者的手段和思维模式，预测并防止潜在的网络攻击，从而提高网络安全防御的效果。”
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic9.png"
              alt=""
            >
          </div>
          <div>
            专家们在论坛上分享了各自在网络安全领域的实践经验和心得体会，深入浅出的演讲为百位与会者提供了宝贵的参考和启示，纷纷表示：此次论坛的召开，不仅开拓了自己在安全运营领域的视野，也提升了自己日后安全工作上的思路。
          </div>
          <div class="blue">
            畅想未来 ·灵创科技以创新助力行业新发展
          </div>
          <!-- <div class="video_size">
            <video
              muted="muted"
              class="video"
              src="@/assets/aboutus/video.mp4"
              type="video/mp4"
              controls="controls"
              ref="videoPlayer"
            >
              <p>你的浏览器不支持video标签.</p>
            </video>
          </div> -->
          <div>
            作为一个专注于网络安全运营的领先企业，灵创科技始终坚持以创新引领行业发展，积极推动网络安全运营实践的落地与普及。在此次论坛中，灵创科技更是充分展示了公司在网络安全运营领域的专业实力，以及对于数字经济发展的独特见解，向更多的合作伙伴和客户展示了我们的专业能力和服务。
          </div>
          <div>
            这个全球化的时代，网络安全问题已经成为一个全球性的挑战。而在这个挑战中，我们也看到了机遇。灵创科技将继续保持敏锐的市场洞察能力和技术创新能力，积极与各位交流与合作，为我们的客户提供更优质的产品和服务。同时，我们也将坚定不移地推进自身的技术创新和业务拓展，为数字经济的发展贡献更多力量。
          </div>
          <div class="img_center">
            <img
              src="@/assets/aboutus/pic10.png"
              alt=""
            >
          </div>
          <div>
            通过这场论坛，我们希望建立一个开放的交流平台，让更多的企业和专家能够分享他们的经验和见解。同时，我们也希望通过这次活动，让更多的人了解灵创科技，了解我们在网络安全运营和数字经济发展方面的努力和贡献。
          </div>
          <div>
            在这个充满机遇与挑战的时代，灵创科技期待与您携手共进，共同打造更加美好的网络空间！感谢您一直以来对灵创科技的支持与信任。让我们共同期待着更加辉煌的未来！
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      title: '灵创网络协议端口识别系统',
      content: '',
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '14:6', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        poster: '@/assets/aboutus/pic2.png',
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false // 全屏按钮
        }
      }

    }
  }
}
</script>

<style scoped>
@import '../../styles/utils.scss';
.sub_title {
  width: 70%;
  margin: 0 auto;
}
.red {
  color: #ff0000;
}
.blue {
  color: #0089bb;
  text-align: center;
  font-size: 33px;
}
.content_list {
  text-indent: 2em;
}
.img_center {
  display: flex;
  justify-content: center;
}
img {
  margin-bottom: 10px;
  width: 100%;
}
video {
  object-fit: fill;
  width: 60%;
  margin: 20px auto;
}
.video_size{
    display: flex;
    justify-content: center;
}
</style>
